import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';
import { ConfermaComponent } from '../conferma/conferma.component';

@Component({
  selector: 'app-dati-bancari',
  templateUrl: './dati-bancari.component.html',
  styleUrls: ['./dati-bancari.component.css']
})
export class DatiBancariComponent implements OnInit {
  titolo: string = "";
  idRichiesta: any;
    objdettaglio: any;

  constructor(private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog, public dialogRef: MatDialogRef<DatiBancariComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Bonifico Bancario'
  }

  ngOnInit(): void {
    console.log(this.data);
    this.idRichiesta = this.data.idRichiesta;

    this.getDettaglio();

 
  }

  getDettaglio() {
    this.srvUtilita.getObj('Utenti/GetRichiesta?idRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objdettaglio = res
      // console.log(res, 'res')
    })
  }

  btnConfermaIlPagamento() {
   
    //  this.router.navigate(['/modalita-di-pagamento/conferma/']);

    const obj = {
      idRichiesta: this.idRichiesta,
      idTipoPagamento: 2
    }

    this.srvUtilita.postObj('utenti/PostSalvaPagamento', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close();

      let dialogRef: MatDialogRef<any> = this.dialog.open(ConfermaComponent, {
        width: '720px',
        disableClose: false,
        data: { idRichiesta: this.idRichiesta } 
      })
      dialogRef.afterClosed()
        .subscribe((res: any) => {
        })


    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

}
